import { productsCategories, productsSlugs, productsVariants } from 'constants/products';

import squaredConditionerPicture from 'assets/images/skincare/haircare-product/d-conditioner.jpg';
import squaredConditionerPictureHover from 'assets/images/skincare/haircare-product/d-conditioner-hover.jpg';
import squaredMaskPicture from 'assets/images/skincare/haircare-product/d-mask.jpg';
import squaredMaskPictureHover from 'assets/images/skincare/haircare-product/d-mask-hover.jpg';
import squaredShampooPicture from 'assets/images/skincare/haircare-product/d-shampoo.jpg';
import squaredShampooPictureHover from 'assets/images/skincare/haircare-product/d-shampoo-hover.jpg';
import squaredStylingGelPicture from 'assets/images/skincare/haircare-product/d-styling-gel.jpg';
import squaredStylingGelPictureHover from 'assets/images/skincare/haircare-product/d-styling-gel-hover.jpg';

import conditionerPicture from '../images/checkout_conditioner.png';
import conditionerPictureWithCap from '../images/checkout_conditioner-cap.png';
import curlCreamPicture from '../images/checkout_curlcream.png';
import curlCreamPictureWithCap from '../images/checkout_curlcream-cap.png';
import dryShampooPicture from '../images/checkout_dryshampoo.png';
import oilPicture from '../images/checkout_hairoil.png';
import leaveinPicture from '../images/checkout_leavein.png';
import leaveinXtraV1Picture from '../images/checkout_leavein_xtra_v1.png';
import leaveinPictureWithCap from '../images/checkout_leavein-cap.png';
import hairMaskPicture from '../images/checkout_mask.png';
import scalpMaskPicture from '../images/checkout_mask.png';
import shampooPicture from '../images/checkout_shampoo.png';
import shampooPictureWithCap from '../images/checkout_shampoo-cap.png';
import stylingGelPicture from '../images/checkout_stylinggel.png';
import supplementsPicture from '../images/checkout_supplements.png';
import supplementsPouchPicture from '../images/checkout_supplements_pouches.png';
import conditionerBgPicture from '../images/productPages/conditioner_carousel_1.jpg';
import conditionerBgLabelledPicture from '../images/productPages/conditioner_carousel_2.jpg';
import curlCreamBgPicture from '../images/productPages/curlcream_carousel_1.jpg';
import curlCreamBgLabelledPicture from '../images/productPages/curlcream_carousel_2.jpg';
import dryShampooBgPicture from '../images/productPages/dryshampoo_carousel_1.jpg';
import dryShampooBgLabelledPicture from '../images/productPages/dryshampoo_carousel_2.jpg';
import leaveinBgPicture from '../images/productPages/leavein_carousel_1.jpg';
import leaveinBgLabelledPicture from '../images/productPages/leavein_carousel_2.jpg';
import hairMaskBgPicture from '../images/productPages/mask_carousel_1.jpg';
import hairMaskBgLabelledPicture from '../images/productPages/mask_carousel_2.jpg';
import oilBgPicture from '../images/productPages/oil_carousel_1.jpg';
import oilBgLabelledPicture from '../images/productPages/oil_carousel_2.jpg';
import scalpMaskBgPicture from '../images/productPages/scalpmask_carousel_1.jpg';
import scalpMaskBgLabelledPicture from '../images/productPages/scalpmask_carousel_2.jpg';
import shampooBgPicture from '../images/productPages/shampoo_carousel_1.jpg';
import shampooBgLabelledPicture from '../images/productPages/shampoo_carousel_2.jpg';
import stylingGelBgPicture from '../images/productPages/styling_gel_carousel_1.jpg';
import stylingGelBgLabelledPicture from '../images/productPages/styling_gel_carousel_2.jpg';
/* Good to know: numbers directly on assets name is kinda brittle when a PM ask you to change images orders.
 That's why we don't go this road here. */
import supplementsBgPicture from '../images/productPages/supplements_carousel_jars_dark_bg.jpg';
import supplementsBgLabelledPicture from '../images/productPages/supplements_carousel_jars_light_bg.jpg';

export const hair_mask = {
  capacity: '8.5 fl oz',
  cat: 'core',
  description:
    'A highly concentrated pre-shampoo treatment that restores moisture and smoothness to hair lengths and ends. Your personalized formula is made to nourish your hair to promote stronger, visibly healthy hair.',
  label: 'Pre-Shampoo Hair Mask',
  picture: hairMaskPicture,
  bgPicture: hairMaskBgPicture,
  bgLabelledPicture: hairMaskBgLabelledPicture,
  productSquaredPicture: squaredMaskPicture,
  productSquaredPictureHover: squaredMaskPictureHover,
  price: 45,
  productPageUrl: '/products/custom-hair-mask',
  slug: productsSlugs.HAIR_MASK,
  tag: 'Hydrate & Repair',
  type: productsCategories.FORMULA,
  usage: 'Approximately 8-10 weeks use.',
  usageB: '2x a week',
  category: productsCategories.HAIRCARE,
};

export const shampoo = {
  capacity: '8.5 fl oz',
  cat: 'core',
  description:
    'A gentle, clarifying shampoo that does it all, from rebalancing roots to gently hydrating lengths. Prose’s personalized formulas are uniquely designed for all hair types to cleanse your scalp and nourish your hair with every wash.',
  label: 'Shampoo',
  picture: shampooPicture,
  pictureWithCap: shampooPictureWithCap,
  bgPicture: shampooBgPicture,
  bgLabelledPicture: shampooBgLabelledPicture,
  productSquaredPicture: squaredShampooPicture,
  productSquaredPictureHover: squaredShampooPictureHover,
  productPageUrl: '/products/custom-shampoo',
  price: 32,
  slug: productsSlugs.SHAMPOO,
  tag: 'Cleanse and wash',
  type: productsCategories.FORMULA,
  usage: 'Approximately 8-10 weeks use.',
  usageB: 'Daily',

  category: productsCategories.HAIRCARE,
};

export const conditioner = {
  capacity: '8.5 fl oz',
  cat: 'core',
  description:
    'A nourishing moisturizer that will meet all of your hair goals and restore your strands without ever weighing them down.',
  label: 'Conditioner',
  picture: conditionerPicture,
  pictureWithCap: conditionerPictureWithCap,
  bgPicture: conditionerBgPicture,
  bgLabelledPicture: conditionerBgLabelledPicture,
  productSquaredPicture: squaredConditionerPicture,
  productSquaredPictureHover: squaredConditionerPictureHover,
  productPageUrl: '/products/custom-conditioner',
  price: 32,
  slug: productsSlugs.CONDITIONER,
  tag: 'Hydrate',
  type: productsCategories.FORMULA,
  usage: 'Approximately 8-10 weeks use.',
  usageB: 'Daily',
  category: productsCategories.HAIRCARE,
};

export const leavein = {
  capacity: '1.7 fl oz',
  cat: 'leavein',
  description:
    'Used as a treatment before washing or as a finishing product to style, this premium oil protects strands and smooths away frizz.',
  isNew: false,
  label: 'Hair Oil',
  picture: oilPicture,
  bgPicture: oilBgPicture,
  bgLabelledPicture: oilBgLabelledPicture,
  productSquaredPicture: squaredConditionerPicture,
  productSquaredPictureHover: squaredConditionerPictureHover,
  price: 48,
  productPageUrl: '/products/custom-hair-oil',
  slug: productsSlugs.OIL,
  tag: 'Treat & Style',
  cardTag: 'Award winning',
  type: productsCategories.FORMULA,
  usageB: 'As needed',
  category: productsCategories.HAIRCARE,
};

export const dry_shampoo = {
  capacity: '1.4 oz',
  description:
    'A translucent, powder dry shampoo that refreshes the roots and extends hairstyles, all while caring for your scalp needs.',
  isNew: false,
  label: 'Dry Shampoo',
  picture: dryShampooPicture,
  bgPicture: dryShampooBgPicture,
  bgLabelledPicture: dryShampooBgLabelledPicture,
  productSquaredPicture: squaredConditionerPicture,
  productSquaredPictureHover: squaredConditionerPictureHover,
  price: 28,
  productPageUrl: '/products/custom-dry-shampoo',
  slug: productsSlugs.DRY_SHAMPOO,
  tag: 'Cleanse & Refresh',
  type: productsCategories.FORMULA,
  category: productsCategories.HAIRCARE,
};

export const curl_cream = {
  capacity: '5.1 fl oz',
  description:
    'Used as a styler or for touch-ups, our Curl Cream defines your natural texture — whether your hair is wavy, curly, or coily. Every custom formula is designed to keep strands hydrated and to minimize unwanted frizz, too.',
  isNew: false,
  label: 'Curl Cream',
  picture: curlCreamPicture,
  pictureWithCap: curlCreamPictureWithCap,
  bgPicture: curlCreamBgPicture,
  bgLabelledPicture: curlCreamBgLabelledPicture,
  productSquaredPicture: squaredConditionerPicture,
  productSquaredPictureHover: squaredConditionerPictureHover,
  price: 28,
  productPageUrl: '/products/custom-curl-cream',
  slug: productsSlugs.CURL_CREAM,
  tag: 'Define & De-frizz',
  type: productsCategories.FORMULA,
  category: productsCategories.HAIRCARE,
};

export const leavein_conditioner = {
  capacity: '5.1 fl oz',
  description:
    'This hydrating leave-in conditioner detangles and smooths flyaways, leaving strands soft, polished, and manageable.',
  isNew: false,
  label: 'Leave-In Conditioner',
  picture: leaveinPicture,
  pictureWithCap: leaveinPictureWithCap,
  bgPicture: leaveinBgPicture,
  bgLabelledPicture: leaveinBgLabelledPicture,
  productSquaredPicture: squaredConditionerPicture,
  productSquaredPictureHover: squaredConditionerPictureHover,
  price: 28,
  productPageUrl: '/products/custom-leave-in-conditioner',
  slug: productsSlugs.LEAVEIN_CONDITIONER,
  tag: 'Hydrate & Detangle',
  type: productsCategories.FORMULA,
  variants: {
    [productsVariants.LEAVEIN_CONDITIONER_XTRA_V1]: {
      picture: leaveinXtraV1Picture,
    },
  },
  category: productsCategories.HAIRCARE,
};

export const scalp_mask = {
  capacity: '8.5 fl oz',
  description:
    'An intensive pre-wash treatment that helps restore balance to your scalp, whether you need soothing repair or a gentle detox.',
  label: 'Pre-Shampoo Scalp Mask',
  picture: scalpMaskPicture,
  bgPicture: scalpMaskBgPicture,
  bgLabelledPicture: scalpMaskBgLabelledPicture,
  productSquaredPicture: squaredConditionerPicture,
  productSquaredPictureHover: squaredConditionerPictureHover,
  price: 45,
  productPageUrl: '/products/custom-scalp-mask',
  slug: productsSlugs.SCALP_MASK,
  tag: 'Soothe & Balance',
  type: productsCategories.FORMULA,
  category: productsCategories.HAIRCARE,
};

export const styling_gel = {
  capacity: '8.5 fl oz',
  cat: 'styling_gel',
  description:
    'A versatile styler for curls and coils, this flake-free, non-crunchy gel gives all your favorite hairstyles the right amount of hold and definition while preventing frizz and shrinkage–even in humid weather.',
  label: 'Styling Gel',
  picture: stylingGelPicture,
  bgPicture: stylingGelBgPicture,
  bgLabelledPicture: stylingGelBgLabelledPicture,
  productSquaredPicture: squaredStylingGelPicture,
  productSquaredPictureHover: squaredStylingGelPictureHover,
  price: 30,
  productPageUrl: '/products/custom-styling-gel',
  slug: productsSlugs.STYLING_GEL,
  tag: 'Hold & Define',
  type: productsCategories.FORMULA,
  usageB: 'As needed',
  dataFrom: 'block-products-push',
  dataClick: 'see-product-styling-gel',
  category: productsCategories.HAIRCARE,
};

export const supplement_core = {
  // capacity: '2 bottles, 30 capsules each - 30-day supply',
  capacity: 'One month supply.',
  cat: 'core',
  description: (
    <>
      Your custom <b>Root Source</b>
      <sup>®</sup> hair supplements provide natural and powerful ingredients known to soothe the
      scalp and to stimulate hair growth*, thickness, and density.
      <br />
    </>
  ),
  label: 'Root Source® Hair Supplements',
  shortLabel: 'Root Source®',
  useShortLabel: true,
  displayLabelPdp: 'Custom Hair Supplements',
  displayLabel: (
    <>
      Root Source<sup css={{ fontFamily: 'Simplon Norm', fontSize: 18 }}>®</sup>
    </>
  ),
  labelDetail: (
    <>
      Root Source® Hair Supplements
      <br />2 bottles, one month supply each
      <br /> Two capsules per day
    </>
  ),
  pluralLabel: 'Root Source® Hair Supplements',
  picture: supplementsPicture,
  pictureWithCap: supplementsPicture,
  bgPicture: supplementsBgPicture,
  bgLabelledPicture: supplementsBgLabelledPicture,
  productSquaredPicture: squaredConditionerPicture,
  productSquaredPictureHover: squaredConditionerPictureHover,
  price: 62,
  productPageUrl: '/products/custom-hair-supplements',
  slug: productsSlugs.SUPPLEMENT_CORE,
  tag: 'custom root source®',
  type: productsCategories.FORMULA,
  category: productsCategories.HAIRCARE,
};

export const supplements_pouch = {
  picture: supplementsPouchPicture,
  label: 'Root Source® Hair Supplements',
  pluralLabel: 'Root Source® Hair Supplements',
  labelDetail: (
    <>
      Root Source® Hair Supplements
      <br />2 refill pouches, 30 capsules each, 30 day supply
      <br /> Two capsules per day
    </>
  ),
};

export const productSlugToProductHaircare = {
  [productsSlugs.HAIR_MASK]: hair_mask,
  [productsSlugs.SCALP_MASK]: scalp_mask,
  [productsSlugs.SHAMPOO]: shampoo,
  [productsSlugs.CONDITIONER]: conditioner,
  [productsSlugs.LEAVEIN_CONDITIONER]: leavein_conditioner,
  [productsSlugs.DRY_SHAMPOO]: dry_shampoo,
  [productsSlugs.CURL_CREAM]: curl_cream,
  [productsSlugs.SUPPLEMENT_CORE]: supplement_core,
  [productsSlugs.STYLING_GEL]: styling_gel,
  [productsSlugs.OIL]: leavein,
};
